module.exports = __webpack_public_path__ + "AvenirRoman.b3b06989cdbd59e51633.otf";


//////////////////
// WEBPACK FOOTER
// ./src/app/content/fonts/AvenirRoman.otf
// module id = 180
// module chunks = 1